import React from 'react';
import {Input} from 'semantic-ui-react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils from 'react-day-picker/moment';
import YearMonthForm from 'modules/misc/YearMonthForm.js';
import DateUtils from 'utils/DateUtils.js';

import {spacings, colors} from 'style';

var style = {
    inputWrapper: {
        color: colors.themeDarkerGrey,
        position: 'relative',
        padding: spacings.tiny,
    },
    inputLabel: {
        display: 'block',
        textAlign: 'left',
        paddingRight: spacings.tiny,
    },
    input: {
        width: '384px',
    }
}



const ChallengeQuestionDate = ({challengeQuestion, value, index, onChange, onChangeDateText, format}) => (
    <div style={style.inputWrapper}>
        <label style={style.inputLabel}>{challengeQuestion.label}</label>
        <DayPickerInput
              style={style.input}
              name="date"
              classNames={{container:"DayPickerInput", 
                           overlay:"DayPickerInput-Overlay",
                           overlayWrapper:"DayPickerInput-OverlayWrapper"}}
              placeholder={format}
              format={format}
              value={value}
              component={Input}
              onDayChange={onChange}
              onChange={onChangeDateText}
              dayPickerProps={{locale:localStorage.i18nextLng,
                               localeUtils:MomentLocaleUtils,
                               captionElement:<YearMonthForm onChange={onChange}/>,
                               month:YearMonthForm.fromMonth}}
               /> 
    </div>
);


export default ChallengeQuestionDate;



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionDate.js